export default __webpack_public_path__ + "static/media/undraw-calendar.50f5dace.svg";